import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  tank: [],
};

const tankSlice = createSlice({
  name: 'tank',
  initialState,
  reducers: {
    setAddTank(state, action) {
      const { payload } = action;
      state.tank = [...state.tank, { ...payload }];
    },
    setUpdateTank(state, action) {
      const { payload } = action;
      const { id, data } = payload;
      const updatedTankIndex = state.tank.findIndex((item) => item.id === id);

      if (updatedTankIndex !== -1) {
        state.tank[updatedTankIndex] = {
          ...data,
        };
      }
    },
    deleteTank(state, action) {
      const { payload } = action;
      state.tank = state.tank.filter(
        (item) => Number(item.id) !== Number(payload)
      );
    },
    clearTankList(state) {
      state.tank = initialState.tank;
    },
  },
});

export const { setAddTank, deleteTank, setUpdateTank, clearTankList } =
  tankSlice.actions;
export default tankSlice.reducer;
